import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const reviews = [{
  name: 'Joaquín',
  city: 'Mar del Plata',
  quote: 'En dos meses pasé de explotar a los 3 minutos a aguantar todo el entrenamiento. La parte de acondicionamiento por rounds es brutal.'
}, {
  name: 'Tomás',
  city: 'Córdoba',
  quote: 'Lo que más me sirvió fue el orden. Antes hacía pesas sin sentido; ahora cada sesión tiene un objetivo claro para mi BJJ.'
}, {
  name: 'Nicolás',
  city: 'CABA',
  quote: 'La movilidad de cadera me destrabó la guardia. Hago la rutina de 10 minutos y ya se nota en el roleo. Re recomendado.'
}, {
  name: 'Agustín',
  city: 'Rosario',
  quote: 'Volví de una lesión de rodilla siguiendo el protocolo de prevención. Hoy entreno más fuerte que antes y sin miedo.'
}];
export function MidTestimonials() {
  return <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto" data-id="element-55">
      <div className="text-center mb-10" data-id="element-56">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-white" data-id="element-57">
          Strikers y grapplers{' '}
          <span className="text-amber-400" data-id="element-58">que ya lo llevaron</span>
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-59">
        {reviews.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-zinc-900/50 border border-zinc-800 p-6 rounded-2xl flex flex-col" data-id="element-60">
            <div className="flex gap-1 mb-4" data-id="element-61">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-62" />)}
            </div>
            <p className="text-zinc-300 italic mb-6 flex-grow" data-id="element-63">"{t.quote}"</p>
            <div className="mt-auto pt-4 border-t border-zinc-800/50" data-id="element-64">
              <p className="font-bold text-white" data-id="element-65">{t.name}</p>
              <p className="text-sm text-zinc-500" data-id="element-66">{t.city}, Argentina</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}